import { render, staticRenderFns } from "./SidebarMenuLawyer.vue?vue&type=template&id=3fd77cc8&"
import script from "./SidebarMenuLawyer.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuLawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports